import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/testimonials";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6, ease: [0.19, 1, 0.22, 1] },
};

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative bg-forest-800 border-t border-bone-100/10 py-24 md:py-32 px-6 md:px-12 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto">
        <motion.div {...fadeUp} className="mb-16 max-w-2xl">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-bone-100 tracking-tight leading-[1.05]">
            The <span className="italic text-terracotta-400">only</span> reason
            <br />we're growing.
          </h2>
          <div className="overline text-terracotta-500 mt-4">In their words</div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={i}
              {...fadeUp}
              transition={{ ...fadeUp.transition, delay: i * 0.08 }}
              className="bg-forest-900 border border-bone-100/10 p-8 md:p-10 relative hover:border-terracotta-500/40 transition-colors"
              data-testid={`testimonial-${i}`}
            >
              <Quote
                size={32}
                className="absolute -top-4 -left-3 text-terracotta-500 fill-terracotta-500 bg-forest-800 p-1"
                strokeWidth={0}
              />
              <blockquote className="font-serif text-xl md:text-2xl text-bone-100 leading-relaxed">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-8 flex items-baseline justify-between gap-4 flex-wrap">
                <div>
                  <div className="text-bone-100 font-medium">{t.name}</div>
                  <div className="overline text-bone-100/50 mt-1">{t.location}</div>
                </div>
                <div className="text-terracotta-500 tracking-widest">★★★★★</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
